interface searchCollectionsTypes {
  title?: string;
  page: number;
  limit: number;
}

async function searchCollections(params: searchCollectionsTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const baseUrl = new URL(`${serverURL}/api/collections`);

  const searchParams = new URLSearchParams({
    page: params.page.toString(),
    limit: params.limit.toString(),
  });

  if (params.title) searchParams.set("title", params.title);

  baseUrl.search = searchParams.toString();

  try {
    const res = await fetch(baseUrl.toString(), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return await res.json();
  } catch (error) {
    return null;
  }
}

export default searchCollections;
